import React from 'react';
import {
	CTAScreen,
	HeroWithoutPicture,
	ImagesTable,
} from '@/components/landing/reusableSections';
import {
	useLandingShownEvent,
	useSendToAmplitudeScrolledPercent,
	useTranslationWithLocale,
} from '@/hooks';
import { GenerateLandingLinkService, GoogleService } from '@/services';
import { forBusinessData } from '@/data';
import {
	AMPLITUDE_EVENTS,
	GOOGLE_EVENTS,
	LANDING_AMPLITUDE_EVENTS,
	LOCAL_STORAGE_KEYS,
} from '@/constants';
import ctaScreen from '@/public/images/landing/ctaScreen.webp';
import styles from './ForBusinessLanding.module.scss';

interface Props {}
const ForBusinessLanding: React.FC<Props> = () => {
	const { t } = useTranslationWithLocale('for-business');
	const BASE_PATH = '/for-businesses';
	const goToProduct = () => {
		GoogleService.logEvent(GOOGLE_EVENTS.LANDING_PASSED);
		window.location.href = GenerateLandingLinkService.webApp();
	};

	useSendToAmplitudeScrolledPercent(
		[50, 75, 100],
		LOCAL_STORAGE_KEYS.FOR_BUSINESS_SCROLLED_POINTS,
		AMPLITUDE_EVENTS.WEBAPP_LANDING_SCROLLED,
		{ type: LANDING_AMPLITUDE_EVENTS.FOR_BUSINESS_LANDING },
	);

	useLandingShownEvent({ type: LANDING_AMPLITUDE_EVENTS.FOR_BUSINESS_LANDING });

	return (
		<>
			<HeroWithoutPicture
				title={t('heroData.title')}
				subtitle_1={t('heroData.subtitle')}
				classes={{
					titleClass: styles['business__hero-title'],
				}}
				buttonText={t('getStarted')}
				onClick={goToProduct}
			/>
			<ImagesTable
				t={t}
				data={forBusinessData}
				basePath={BASE_PATH}
				as='link'
				classes={{
					textClass: styles['business__images-text'],
					subTextClass: styles['business__images-sub-text'],
					linkClass: styles['business__images-link'],
				}}
			/>

			{/* TryLift */}
			<CTAScreen
				title1={t('tryLiftData.title1')}
				title_green={t('tryLiftData.greenText')}
				title2={t('tryLiftData.title2')}
				subtitle={t('tryLiftData.subtitle')}
				image={ctaScreen}
				altText={t('tryLiftData.altText')}
				buttonText={t('getStarted')}
				onClick={goToProduct}
				classes={{
					titleInline: styles['business__tryLift-title'],
					subtitleClass: styles['business__tryLift-subtitle'],
				}}
			/>
		</>
	);
};

export default ForBusinessLanding;
